import * as React from "react";

let __idCounter = 0;

function generateId(prefix = "id") {
  __idCounter += 1;
  return `${prefix}-${__idCounter}`;
}

export function useStableId(providedId?: string, prefix?: string) {
  const [id] = React.useState(() => providedId ?? generateId(prefix));
  return id;
}
